import { render, staticRenderFns } from "./schooldetail.vue?vue&type=template&id=52abcb2e&scoped=true"
import script from "./schooldetail.vue?vue&type=script&lang=js"
export * from "./schooldetail.vue?vue&type=script&lang=js"
import style0 from "./schooldetail.vue?vue&type=style&index=0&id=52abcb2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52abcb2e",
  null
  
)

export default component.exports